import React from 'react';

const ContentMetadata = ({ 
  title, 
  description, 
  releaseYear, 
  duration, 
  genres, 
  rating, 
  studio, 
}) => {
  return (
    <div className="content-metadata mb-8">
      <h2 className="text-xl font-bold text-white mb-4">About</h2>
      <div className="text-white/80 space-y-4">
        <p className="text-base">{description}</p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
          {releaseYear && (
            <div>
              <span className="block text-white/50 mb-1">Release Year</span>
              <span>{releaseYear}</span>
            </div>
          )}
          
          {duration && (
            <div>
              <span className="block text-white/50 mb-1">Duration</span>
              <span>{duration}</span>
            </div>
          )}
          
          {genres && (
            <div>
              <span className="block text-white/50 mb-1">Genre</span>
              <span>{genres}</span>
            </div>
          )}
          
          {rating && (
            <div>
              <span className="block text-white/50 mb-1">Rating</span>
              <span>{rating}</span>
            </div>
          )}
          
          {studio && (
            <div>
              <span className="block text-white/50 mb-1">Studio</span>
              <span>{studio}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentMetadata;
